import { render, staticRenderFns } from "./ParaSearch.vue?vue&type=template&id=20e856d6&scoped=true"
import script from "./ParaSearch.vue?vue&type=script&lang=js"
export * from "./ParaSearch.vue?vue&type=script&lang=js"
import style0 from "./ParaSearch.vue?vue&type=style&index=0&id=20e856d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e856d6",
  null
  
)

export default component.exports